import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers, mergeManagerData } from "./../../../component/common/AparEmployeeHeader";
import { getKpiReport, getKpiTaskGrade } from "./../../../actions/AppraisalCycleAction";

class aparAcceptingManagerForm1 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      kpiReportId: null,
      isMouApplicable: false,
      mouTask: null,
      otherKeyTasks: [],
      // Reporting Authority KPI grades
      repMouGrade: '',
      repMouWeightedGrade: 0,
      repTaskGrades: [] as any[],
      // Reviewing Authority KPI grades
      revMouGrade: '',
      revMouWeightedGrade: 0,
      revTaskGrades: [] as any[],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Acceptance Authority - KPI Report - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { kpiReportId: passedKpiReportId, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData, showLoader: true });

    if (employeeCode && effectiveFrom) {
      getKpiReport({ employeeCode, effectiveFrom, reportType: 'employee' }).then((res: any) => {
        const report = res?.result || null;
        if (report) {
          const kpiReportId = report.id || passedKpiReportId || null;
          const mouTask = report.tasks?.find((t: any) => t.particular === '*)') || null;
          const otherTasks = report.tasks?.filter((t: any) => t.particular !== '*)') || [];
          const isMouApplicable = !!mouTask;

          this.setState((prev: any) => ({
            kpiReportId,
            isMouApplicable,
            mouTask,
            otherKeyTasks: otherTasks,
            repTaskGrades: otherTasks.map((t: any) => ({ id: t.id, grade: '', weightedGrade: 0 })),
            revTaskGrades: otherTasks.map((t: any) => ({ id: t.id, grade: '', weightedGrade: 0 })),
            employeeData: { ...prev.employeeData, ...mergeManagerData(prev.employeeData, report) },
          }), () => {
            if (kpiReportId) {
              this.loadAllGrades(kpiReportId);
            } else {
              this.setState({ showLoader: false });
            }
          });
        } else {
          this.setState({ showLoader: false });
        }
      });
    } else {
      this.setState({ showLoader: false });
    }
  }

  loadAllGrades = (kpiReportId: any) => {
    getKpiTaskGrade({ kpiReportId, gradedByRole: "reporting" }).then((res: any) => {
      const resData = res?.result || res;
      const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
      if (grades.length > 0) {
        const { mouTask, otherKeyTasks } = this.state;
        const gradeMap: any = {};
        grades.forEach((g: any) => { gradeMap[g.kpi_task_id] = g; });

        let repMouGrade = '';
        let repMouWeightedGrade = 0;
        if (mouTask && gradeMap[mouTask.id]) {
          repMouGrade = String(gradeMap[mouTask.id].absolute_grade || '');
          repMouWeightedGrade = parseFloat(gradeMap[mouTask.id].weighted_grade) || 0;
        }

        const repTaskGrades = otherKeyTasks.map((t: any) => {
          const existing = gradeMap[t.id];
          return existing
            ? { id: t.id, grade: String(existing.absolute_grade || ''), weightedGrade: parseFloat(existing.weighted_grade) || 0 }
            : { id: t.id, grade: '', weightedGrade: 0 };
        });

        this.setState({ repMouGrade, repMouWeightedGrade, repTaskGrades });
      }
      this.loadReviewingKpiGrades(kpiReportId);
    }).catch(() => {
      this.loadReviewingKpiGrades(kpiReportId);
    });
  };

  loadReviewingKpiGrades = (kpiReportId: any) => {
    getKpiTaskGrade({ kpiReportId, gradedByRole: "reviewing" }).then((res: any) => {
      const resData = res?.result || res;
      const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
      if (grades.length > 0) {
        const { mouTask, otherKeyTasks } = this.state;
        const gradeMap: any = {};
        grades.forEach((g: any) => { gradeMap[g.kpi_task_id] = g; });

        let revMouGrade = '';
        let revMouWeightedGrade = 0;
        if (mouTask && gradeMap[mouTask.id]) {
          revMouGrade = String(gradeMap[mouTask.id].absolute_grade || '');
          revMouWeightedGrade = parseFloat(gradeMap[mouTask.id].weighted_grade) || 0;
        }

        const revTaskGrades = otherKeyTasks.map((t: any) => {
          const existing = gradeMap[t.id];
          return existing
            ? { id: t.id, grade: String(existing.absolute_grade || ''), weightedGrade: parseFloat(existing.weighted_grade) || 0 }
            : { id: t.id, grade: '', weightedGrade: 0 };
        });

        this.setState({ revMouGrade, revMouWeightedGrade, revTaskGrades, showLoader: false });
      } else {
        this.setState({ showLoader: false });
      }
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  calculateRepTasksTotal = () => this.state.repTaskGrades.reduce((sum: number, t: any) => sum + (t.weightedGrade || 0), 0);
  calculateRevTasksTotal = () => this.state.revTaskGrades.reduce((sum: number, t: any) => sum + (t.weightedGrade || 0), 0);

  onNext = () => {
    const { employeeData, kpiReportId } = this.state;
    this.props.history.push({
      pathname: CONSTANT.component.aparAcceptingManagerForm3.url,
      state: {
        ...employeeData,
        kpiReportId,
      },
    });
  };

  render() {
    const { showLoader, employeeData, isMouApplicable, mouTask, otherKeyTasks,
      repMouGrade, repMouWeightedGrade, repTaskGrades,
      revMouGrade, revMouWeightedGrade, revTaskGrades } = this.state;

    const repTasksTotal = this.calculateRepTasksTotal();
    const revTasksTotal = this.calculateRevTasksTotal();
    const repGrandTotal = (isMouApplicable ? repMouWeightedGrade : 0) + repTasksTotal;
    const revGrandTotal = (isMouApplicable ? revMouWeightedGrade : 0) + revTasksTotal;

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Acceptance Authority - KPI Report</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="accepting" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {!showLoader && !this.state.kpiReportId && (
                  <div>
                    <div className="alert alert-warning d-flex align-items-center" role="alert">
                      <i className="fa fa-exclamation-triangle mr-2" style={{ fontSize: '1.5rem' }} />
                      <div>
                        <strong>KPI Report Not Available</strong>
                        <p className="mb-0 mt-1">
                          The KPI report for this employee has not been uploaded by HR yet.
                          Please contact HR to upload the KPI report before proceeding with the appraisal.
                        </p>
                      </div>
                    </div>
                    {/* <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        <i className="fa fa-arrow-left mr-1" />Back
                      </button>
                    </div> */}
                  </div>
                )}

                {!showLoader && this.state.kpiReportId && (
                  <div>
                    {/* Section 6 - KPI Assessment */}
                    <h2 className="fs-5 fw-bold border-bottom pb-2 mb-4">
                      Assessment of Achievements against Targets
                      <small className="text-muted fw-normal ms-2">(Weightage: 75%)</small>
                    </h2>

                    <div className="table-responsive mb-4">
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                          <tr>
                            <th rowSpan={2} style={{ width: '30%' }}>Particulars</th>
                            <th rowSpan={2} style={{ width: '10%' }} className="text-center">Weightage (a)</th>
                            <th colSpan={2} className="text-center">Reporting Authority</th>
                            <th colSpan={2} className="text-center">Reviewing Authority</th>
                          </tr>
                          <tr>
                            <th className="text-center" style={{ width: '15%' }}>Absolute Grade</th>
                            <th className="text-center" style={{ width: '15%' }}>Weighted Grade</th>
                            <th className="text-center" style={{ width: '15%' }}>Absolute Grade</th>
                            <th className="text-center" style={{ width: '15%' }}>Weighted Grade</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="table-secondary">
                            <td colSpan={6} className="fw-semibold">I – MoU Targets</td>
                          </tr>

                          {isMouApplicable && mouTask ? (
                            <tr>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>*)</span>
                                  <span>{mouTask.task_description || ''}</span>
                                </div>
                              </td>
                              <td className="text-center">{mouTask.weightage || ''}</td>
                              <td className="text-center">{repMouGrade || '—'}</td>
                              <td className="text-center">{repMouWeightedGrade > 0 ? repMouWeightedGrade.toFixed(2) : '—'}</td>
                              <td className="text-center">{revMouGrade || '—'}</td>
                              <td className="text-center">{revMouWeightedGrade > 0 ? revMouWeightedGrade.toFixed(2) : '—'}</td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan={6} className="text-muted fst-italic ps-3 small">MoU not applicable</td>
                            </tr>
                          )}

                          <tr className="table-secondary">
                            <td colSpan={6} className="fw-semibold">II – Other Key Assigned Tasks flowing from KPI</td>
                          </tr>

                          {otherKeyTasks.length === 0 ? (
                            <tr>
                              <td colSpan={6} className="text-muted fst-italic ps-3 small">No tasks available.</td>
                            </tr>
                          ) : (
                            otherKeyTasks.map((task: any, idx: number) => (
                              <tr key={task.id}>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>{task.particular}</span>
                                    <span>{task.task_description || ''}</span>
                                  </div>
                                </td>
                                <td className="text-center">{task.weightage || ''}</td>
                                <td className="text-center">{repTaskGrades[idx]?.grade || '—'}</td>
                                <td className="text-center">{repTaskGrades[idx]?.weightedGrade > 0 ? repTaskGrades[idx].weightedGrade.toFixed(2) : '—'}</td>
                                <td className="text-center">{revTaskGrades[idx]?.grade || '—'}</td>
                                <td className="text-center">{revTaskGrades[idx]?.weightedGrade > 0 ? revTaskGrades[idx].weightedGrade.toFixed(2) : '—'}</td>
                              </tr>
                            ))
                          )}

                          <tr className="table-light fw-semibold">
                            <td className="text-end pe-3">Total (i to v)</td>
                            <td></td>
                            <td></td>
                            <td className="text-center">{repTasksTotal > 0 ? repTasksTotal.toFixed(2) : '—'}</td>
                            <td></td>
                            <td className="text-center">{revTasksTotal > 0 ? revTasksTotal.toFixed(2) : '—'}</td>
                          </tr>
                          <tr className="table-secondary fw-bold">
                            <td className="text-end pe-3">Grand Total I & II</td>
                            <td className="text-center">75</td>
                            <td></td>
                            <td className="text-center">{repGrandTotal > 0 ? repGrandTotal.toFixed(2) : '—'}</td>
                            <td></td>
                            <td className="text-center">{revGrandTotal > 0 ? revGrandTotal.toFixed(2) : '—'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        Back
                      </button>
                      <button type="button" className="btn btn-primary" onClick={this.onNext}>
                        Next <i className="fa fa-arrow-right ml-1" />
                      </button>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparAcceptingManagerForm1);
